enum EditionType {
    STANDARD = "standard",
    SPECIAL = "special",
    ENERGY_CONTENT_PACK = "energyContentPack",
    UPROAR_CONTENT_PACK = "uproarContentPack",
    SUPER_SIZE_CONTENT_PACK = "superSizeContentPack",
    WILD_SPIRITS_CONTENT_PACK = "wildSpiritsContentPack",
}

export default EditionType;
